<template>
  <v-row class="main-container pa-3" no-gutters>
    <dialog-shipment-information
      v-model="selectedShipmentId"
      :dialog="dialogShipmentInformation"
      v-on:dialog-close="onDialogClose"
    ></dialog-shipment-information>

    <!-- Shipment workflow dialog -->
    <v-dialog v-model="dialogShipmentWorkflow" max-width="90%">
      <template v-if="selectedShipment != null && dialogShipmentWorkflow">
        <v-card
          flat
          tile
          :color="
            selectedShipment.shipment_workflow.completed ? 'white' : 'grey lighten-5'
          "
        >
          <v-card-title class="dialog-header-title"
            >Shipment Workflow for {{ selectedShipment.shipment_order_id }}</v-card-title
          >
          <v-card-text class="pb-0 px-0">
            <shipment-workflow-view
              :shipment="selectedShipment"
              :color="selectedShipment.shipment_workflow.completed ? 'white' : '#FAFAFA'"
            ></shipment-workflow-view>
          </v-card-text>

          <v-divider class="my-0"></v-divider>

          <v-card-actions class="white">
            <v-row justify="end">
              <v-btn
                class="font-weight-bold"
                color="error"
                depressed
                tile
                dark
                @click="dialogShipmentWorkflow = false"
                >CLOSE</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-col cols="12">
      <v-toolbar flat>
        <h3>Shipments</h3>
        <v-spacer></v-spacer>
        <v-autocomplete
          class="form-control search-bar"
          :items="sortedCompanies"
          return-object
          v-model="selectedCompany"
          item-text="name"
          style="float: right"
          clearable
          v-if="isAdmin"
        ></v-autocomplete>
      </v-toolbar>
    </v-col>
    <v-col>
      <v-toolbar flat>
        <v-btn outlined class="mr-4" @click="setToday">Today</v-btn>
        <v-btn fab text small @click="prev">
          <v-icon small>arrow_back_ios</v-icon>
        </v-btn>
        <v-btn fab text small @click="next">
          <v-icon small>arrow_forward_ios</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom right>
          <template v-slot:activator="{ on }">
            <v-btn outlined v-on="on">
              <span>{{ typeToLabel[calendarType] }}</span>
              <v-icon right>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <!-- <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
            </v-list-item>-->
            <v-list-item @click="calendarType = 'week'">
              <v-list-item-title>Week</v-list-item-title>
            </v-list-item>
            <v-list-item @click="calendarType = 'month'">
              <v-list-item-title>Month</v-list-item-title>
            </v-list-item>
            <v-list-item @click="calendarType = '4day'">
              <v-list-item-title>4 days</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-calendar
        ref="calendar"
        color="primary"
        :type="calendarType"
        v-model="calendarFocus"
        :now="today"
        @change="updateRange"
        :events="events"
        :event-color="getEventColor"
        :event-margin-bottom="3"
        @click:more="viewWeek"
        @click:date="viewWeek"
        @click:event="showEvent"
      ></v-calendar>
      <v-menu
        v-model="selectedOpen"
        :close-on-content-click="false"
        :activator="selectedElement"
        offset-x
      >
        <v-card color="grey lighten-4" min-width="350px" flat>
          <v-toolbar :color="selectedEvent.color" dark>
            <v-toolbar-title
              v-html="calendarCardTitle"
              style="font-size: 16px"
            ></v-toolbar-title>
          </v-toolbar>
          <v-card-text class="px-5">
            <span style="color: black" v-html="selectedEvent.details"></span>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary" @click="onShipmentInfo">Info</v-btn>
            <v-btn text color="primary" @click="onShipmentWorkflowDialog">Workflow</v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="secondary" @click="selectedOpen = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import constant from "../../const";
import DialogShipmentInformation from "@/components/user/DialogShipmentInformation";
import ShipmentWorkflowView from "@/components/shared/ShipmentWorkflowView.vue";

export default {
  components: { DialogShipmentInformation, ShipmentWorkflowView },

  data() {
    return {
      companies: [],
      selectedCompany: null,
      shipments: [],

      calendarType: "month",
      typeToLabel: {
        month: "Month",
        week: "Week",
        day: "Day",
        "4day": "4 Days",
      },

      today: null,
      calendarFocus: null,
      start: null,
      end: null,
      events: [],
      unplannedEvents: [],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,

      selectedShipment: null,
      selectedShipmentId: null,
      dialogShipmentInformation: false,
      dialogShipmentWorkflow: false,
    };
  },

  async created() {
    // verify user token
    await this.$root.verify_user_token();

    this.initializeShipmentList();
    this.loadCompanies();
  },

  mounted() {
    this.today = constant.getDate(0);
    this.calendarFocus = constant.getDate(0);
  },

  methods: {
    loadCompanies() {
      if (this.isAdmin) {
        this.$https
          .get("/api/company/list")
          .then((response) => {
            this.companies = response.data.data;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {});
      }
    },

    initializeShipmentList() {
      var response = null;
      this.$root.blockUImsg = "Loading shipments";
      this.$root.blockUIshow = true;

      // if (!isAppend) {
      //     this.getShipmentDashboardInfo();
      // }

      let requestString =
        "/api/shipment_orders/list/calendar?shipment=true&completed=false";

      if (this.selectedCompany != null) {
        requestString = requestString + "&company_id=" + this.selectedCompany.company_id;
      }

      this.$https
        .get(requestString)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          if (response != null && response.status == constant.RESPONSE_STATUS_OK) {
            this.shipments = response.data.data;
            this.initializeEvents();
          } else {
            console.log("Error loading shipments list", response);
          }
          this.$root.blockUIshow = false;
        });
    },

    initializeEvents() {
      this.events = [];

      this.shipments.forEach((element) => {
        if (element != null && element.quotation.shipment_schedule != null) {
          var quotation = element.quotation;

          // Calendar events for shipment schedule (arrival and departure)
          if (quotation.shipment_schedule != null) {
            var eta = null;
            var transactionAbbv = null;
            var port = null;
            var tag = null;
            var color = null;

            // Vessel departure schedule
            eta = element.quotation.shipment_schedule.origin_eta;
            transactionAbbv = "DEP";
            tag = "DEPARTURE";
            port = element.quotation.origin_port.un_code;
            color =
              element.quotation.transaction_type == "EXPORT" ? "#1E88E5" : "#95C623";

            if (eta != null && eta.trim() != "") {
              this.events.push({
                name: `${element.shipment_order_id} ${transactionAbbv} ${port}`,
                start: constant.getDateFromDateTimeString(eta),
                color: color,
                details: this.getEventDetails(element),
                shipment: element,
                tag: tag,
                port: port,
              });
            }

            // Vessel arrival schedule
            eta = element.quotation.shipment_schedule.destination_eta;
            transactionAbbv = "ARR";
            tag = "ARRIVAL";
            port = element.quotation.destination_port.un_code;
            color =
              element.quotation.transaction_type == "EXPORT" ? "#87BFFF" : "#43A047";

            if (eta != null && eta.trim() != "") {
              this.events.push({
                name: `${element.shipment_order_id} ${transactionAbbv} ${port}`,
                start: constant.getDateFromDateTimeString(eta),
                color: color,
                details: this.getEventDetails(element),
                shipment: element,
                tag: tag,
                port: port,
              });
            }
          } else {
            this.unplannedEvents.push({
              shipment: element,
              tag: "SHIPMENT_SCHEDULE",
            });
          }

          color = "#B1740F";
          // Calendar events for transport pickups/deliveries
          if (
            element.transport_export != null &&
            element.transport_export.schedule != null
          ) {
            var start = element.transport_export.schedule.start_datetime;
            var end = element.transport_export.schedule.end_datetime;
            var transactionAbbv = "TRE";
            if (start != null && start.trim() != "" && end != null && end.trim() != "") {
              this.events.push({
                name: `${element.shipment_order_id} ${transactionAbbv} ${port}`,
                start: start,
                end: end,
                color: color,
                details: this.getEventDetails(element),
                shipment: element,
                tag: tag,
                port: port,
              });
            } else {
              this.unplannedEvents.push({
                shipment: element,
                tag: "TRANSPORT_EXPORT",
              });
            }
          }

          if (
            element.transport_import != null &&
            element.transport_import.schedule != null
          ) {
            var start = element.transport_import.schedule.start_datetime;
            var end = element.transport_import.schedule.end_datetime;
            var transactionAbbv = "TRI";
            if (start != null && start.trim() != "" && end != null && end.trim() != "") {
              this.events.push({
                name: `${element.shipment_order_id} ${transactionAbbv} ${port}`,
                start: start,
                end: end,
                color: color,
                details: this.getEventDetails(element),
                shipment: element,
                tag: tag,
                port: port,
              });
            } else {
              this.unplannedEvents.push({
                shipment: element,
                tag: "TRANSPORT_IMPORT",
              });
            }
          }

          // Calendar events for haulage deliveries/pullback
          color = "#E55812";
          // Haulage export
          if (element.haulage_export != null) {
            var port = element.quotation.origin_port.un_code;
            // Delivery
            if (element.haulage_export.delivery_schedule != null) {
              var start = element.haulage_export.delivery_schedule.start_datetime;
              var end = element.haulage_export.delivery_schedule.end_datetime;
              var transactionAbbv = "HED";

              if (
                start != null &&
                start.trim() != "" &&
                end != null &&
                end.trim() != ""
              ) {
                this.events.push({
                  name: `${element.shipment_order_id} ${transactionAbbv} ${port}`,
                  start: start,
                  end: end,
                  color: color,
                  details: this.getEventDetails(element),
                  shipment: element,
                  tag: tag,
                  port: port,
                });
              } else {
                this.unplannedEvents.push({
                  shipment: element,
                  tag: "HAULAGE_EXP_DEL",
                });
              }
            }

            // Pullback
            if (element.haulage_export.pull_back_schedule != null) {
              var start = element.haulage_export.pull_back_schedule.start_datetime;
              var end = element.haulage_export.pull_back_schedule.end_datetime;
              var transactionAbbv = "HEP";

              if (
                start != null &&
                start.trim() != "" &&
                end != null &&
                end.trim() != ""
              ) {
                this.events.push({
                  name: `${element.shipment_order_id} ${transactionAbbv} ${port}`,
                  start: start,
                  end: end,
                  color: color,
                  details: this.getEventDetails(element),
                  shipment: element,
                  tag: tag,
                  port: port,
                });
              } else {
                this.unplannedEvents.push({
                  shipment: element,
                  tag: "HAULAGE_EXP_PUL",
                });
              }
            }
          }

          // Haulage import
          if (element.haulage_import != null) {
            var port = element.quotation.destination_port.un_code;
            // console.log('Haulage import', element.shipment_order_id, element)
            // Delivery
            if (element.haulage_import.delivery_schedule != null) {
              var start = element.haulage_import.delivery_schedule.start_datetime;
              var end = element.haulage_import.delivery_schedule.end_datetime;
              var transactionAbbv = "HID";

              if (
                start != null &&
                start.trim() != "" &&
                end != null &&
                end.trim() != ""
              ) {
                this.events.push({
                  name: `${element.shipment_order_id} ${transactionAbbv} ${port}`,
                  start: start,
                  end: end,
                  color: color,
                  details: this.getEventDetails(element),
                  shipment: element,
                  tag: tag,
                  port: port,
                });
              } else {
                this.unplannedEvents.push({
                  shipment: element,
                  tag: "HAULAGE_IMP_DEL",
                });
              }
            }

            // Pull back
            if (element.haulage_import.pull_back_schedule != null) {
              var start = element.haulage_import.pull_back_schedule.start_datetime;
              var end = element.haulage_import.pull_back_schedule.end_datetime;
              var transactionAbbv = "HIP";

              if (
                start != null &&
                start.trim() != "" &&
                end != null &&
                end.trim() != ""
              ) {
                this.events.push({
                  name: `${element.shipment_order_id} ${transactionAbbv} ${port}`,
                  start: start,
                  end: end,
                  color: color,
                  details: this.getEventDetails(element),
                  shipment: element,
                  tag: tag,
                  port: port,
                });
              } else {
                this.unplannedEvents.push({
                  shipment: element,
                  tag: "HAULAGE_IMP_PUL",
                });
              }
            }
          }
        }
      });
    },

    setToday() {
      this.calendarFocus = this.today;
    },

    prev() {
      this.$refs.calendar.prev();
    },

    next() {
      this.$refs.calendar.next();
    },

    updateRange({ start, end }) {
      // You could load events from an outside source (like database) now that we have the start and end dates on the calendar

      this.start = start;
      this.end = end;
    },

    nth(d) {
      return d > 3 && d < 21
        ? "th"
        : ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"][d % 10];
    },

    getShipmentColor(shipment) {
      if (shipment.quotation.transaction_type == "EXPORT") {
        return "#1E88E5";
      } else {
        return "#43A047";
      }
    },

    getEventDetails(event) {
      var details = null;

      if (this.isAdmin) {
        details = `<b>Customer:</b> ${event.quotation.company.name}  <br>
                  <b>Route:</b> ${event.quotation.origin_port.un_code} - ${
          event.quotation.destination_port.un_code
        } <br>
                  <b>Vessel:</b> ${event.quotation.shipment_schedule.vessel_name} <br> 
                  <b>ETA Origin:</b> ${constant.getDateFromDateTimeString(
                    event.quotation.shipment_schedule.origin_eta
                  )} <br>
                  <b>ETA Destination:</b> ${constant.getDateFromDateTimeString(
                    event.quotation.shipment_schedule.destination_eta
                  )} <br>
                  <b>Transit duration:</b> ${
                    event.quotation.shipment_schedule.transit_duration
                  } days`;
      } else {
        details = `<b>Route:</b> ${event.quotation.origin_port.un_code} - ${
          event.quotation.destination_port.un_code
        } <br>
                  <b>Vessel:</b> ${event.quotation.shipment_schedule.vessel_name} <br> 
                  <b>ETA Origin:</b> ${constant.getDateFromDateTimeString(
                    event.quotation.shipment_schedule.origin_eta
                  )} <br>
                  <b>ETA Destination:</b> ${constant.getDateFromDateTimeString(
                    event.quotation.shipment_schedule.destination_eta
                  )} <br>
                  <b>Transit duration:</b> ${
                    event.quotation.shipment_schedule.transit_duration
                  } days`;
      }

      return details;
    },

    getEventColor(event) {
      return event.color;
    },

    viewWeek({ date }) {
      this.focus = date;
      this.calendarType = "week";
    },

    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },

    onShipmentInfo() {
      this.$root.blockUImsg = "Loading shipment information";
      this.$root.blockUIshow = true;
      this.$https
        .get(`/api/shipment_orders/${this.selectedEvent.shipment.shipment_order_id}`)
        .then((resp) => {
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.selectedShipmentId = resp.data.data.shipment_order_id;
            this.dialogShipmentInformation = true;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$root.blockUIshow = false;
        });
    },

    /**
     * On open shipment workflow dialog
     */
    async onShipmentWorkflowDialog() {
      // get the shipment workflow summary
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(
        `/api/shipment_orders/${this.selectedEvent.shipment.shipment_order_id}/workflow`
      );

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.selectedShipment = resp.data.data;

        this.dialogShipmentWorkflow = true;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },

    onDialogClose() {
      this.dialogShipmentInformation = false;
      this.selectedShipment = null;
      this.selectedShipmentId = null;
    },

    // onManageShipmentWorkflow() {
    //   if (this.selectedEvent != null) {
    //     let routeData = this.$router.resolve({
    //       name: "shipmentworkflow",
    //       params: { id: this.selectedEvent.shipment.shipment_order_id }
    //     })

    //     // open view in a new windows tab
    //     window.open(
    //       routeData.href +
    //         "?id=" +
    //         this.selectedEvent.shipment.shipment_order_id,
    //       "_blank"
    //     )
    //   }
    // }
  },

  computed: {
    isAdmin() {
      return this.$store.state.user.role == constant.ACCOUNT_ADMIN;
    },

    sortedCompanies: function () {
      return this.companies.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },

    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }

      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? "" : endMonth;

      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? "" : endYear;

      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);

      switch (this.calendarType) {
        case "month":
          return `${startMonth} ${startYear}`;
        case "week":
        case "4day":
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
        case "day":
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return "";
    },

    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long",
      });
    },

    calendarCardTitle: {
      get() {
        if (this.selectedEvent.shipment != null) {
          var connector = this.selectedEvent.tag == "DEPARTURE" ? "from" : "at";

          return `${this.selectedEvent.shipment.shipment_order_id}: 
                            ${this.selectedEvent.tag} ${connector} ${this.selectedEvent.port}`;
        } else {
          return "";
        }
      },
    },
  },

  watch: {
    selectedCompany: function () {
      this.initializeShipmentList();
    },
  },
};
</script>

<style></style>
